module.exports = __webpack_public_path__ + "static/media/logo.226a0a61.svg";